"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const R2BTopNavCashIcon = createSVGIcon(
  <>
    <path
      opacity=".6"
      transform="rotate(-45 .531 18.468)"
      fill="#fff"
      d="M.531 18.468H26.648999999999997V44.586H.531z"
    />
    <path
      opacity=".6"
      transform="rotate(-45 .531 18.468)"
      fill="#C9D3C5"
      d="M.531 18.468H26.648999999999997V44.586H.531z"
    />
    <path
      d="M19.092 18.07v-.01c-.011-.493.415-.87 1.178-.943v2.01c-.953-.272-1.178-.576-1.178-1.057m3.286 3.56v.02c0 .545-.438.9-1.211.974v-2.062c.941.261 1.21.575 1.21 1.068m1.031-4.712a4.6 4.6 0 0 0-2.197-.827v-.66h-.987v.64c-1.458.104-2.445.9-2.445 2.062v.02c0 1.215.785 1.801 2.49 2.21v2.22c-.774-.116-1.413-.45-2.075-.964l-.718.953a5.45 5.45 0 0 0 2.748 1.089v1.089h.986v-1.068c1.48-.126 2.479-.911 2.479-2.105v-.02c.01-1.163-.763-1.812-2.523-2.22V17.18c.538.105 1.076.356 1.603.712z"
      fill="#333"
    />
    <path
      fill="#DFE5DC"
      stroke="#333"
      strokeLinejoin="round"
      d="M7.498 12.5H33.498V27.5H7.498z"
    />
    <path stroke="#333" strokeLinejoin="round" d="M7.5 12.5H33.5V27.5H7.5z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m16.45 13-.131.163c-.253.323-.596.809-.941 1.44A11.24 11.24 0 0 0 14 20a11.24 11.24 0 0 0 2.319 6.837l.13.163h8.101l.131-.163c.253-.323.596-.809.941-1.44C26.312 24.131 27 22.295 27 20a11.24 11.24 0 0 0-2.319-6.837l-.13-.163zM25 28s3-3 3-8-3-8-3-8h-9s-3 3-3 8 3 8 3 8zm-8.292-.706.002.001zm0 .001"
      fill="#333"
    />
    <path
      d="M18.615 18.07v-.01c-.011-.493.415-.87 1.177-.943v2.01c-.953-.272-1.177-.576-1.177-1.057m3.285 3.56v.02c0 .545-.437.9-1.21.974v-2.062c.941.261 1.21.575 1.21 1.067m1.032-4.712a4.6 4.6 0 0 0-2.198-.827v-.66h-.987v.639c-1.457.105-2.444.9-2.444 2.063v.02c0 1.215.785 1.801 2.489 2.21v2.22c-.774-.116-1.413-.451-2.074-.964l-.718.953a5.45 5.45 0 0 0 2.747 1.089v1.088h.987v-1.067c1.48-.126 2.478-.911 2.478-2.105v-.02c.011-1.163-.762-1.812-2.523-2.22V17.18c.538.104 1.076.356 1.604.712z"
      fill="#333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 9h27v.97H4.982V25H4z"
      fill="#333"
    />
  </>,
  "R2BTopNavCashIcon",
  { viewBox: "0 0 38 37", titleAccess: "R2BTopNavCashIcon", fill: "none" }
);
